import React from 'react';
import { Calendar } from 'components';
import styles from './Render.module.scss';

// Chrome-less calendar used by scripts/generate-calendar-image.js to
// screenshot the current month. Not linked from anywhere in the UI.
const eventTypeIds = ['in_game', 'twitch_drop', 'race_of_legends', 'sot_shot', 'community'];

const Render = () => (
  <div className={styles.render} data-screenshot-target>
    <Calendar isStatic eventTypeIds={eventTypeIds} />
  </div>
);

export default Render;
